import {
    FETCH_TICKET_DATA
  } from "./../type";
  
  const initialState = {
    ticketList:[],
  };
  
  const ticketReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_TICKET_DATA : 
        return {
          ...state,
          ticketList: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default ticketReducer;
  